import { FaBasketballBall, FaRunning } from "react-icons/fa";

import { GiTennisCourt, GiShuttlecock } from "react-icons/gi";

// Hero Image
import heroImage from "../assets/services/volleyball/hero.webp";
import overview1 from "../assets/services/volleyball/overview1.webp";
import overview2 from "../assets/services/volleyball/overview2.webp";
import overview3 from "../assets/services/volleyball/overview3.webp";
import overview4 from "../assets/services/volleyball/overview4.webp";
/* =====================================================
   HERO STATS
===================================================== */

// Gallery Images
import gallery1 from "../assets/services/volleyball/gallery1.webp";
import gallery2 from "../assets/services/volleyball/gallery2.webp";
import gallery3 from "../assets/services/volleyball/gallery3.webp";
import gallery4 from "../assets/services/volleyball/gallery4.webp";

const volleyballData = {
  /* =====================================================
     HERO
  ====================================================== */

  slug: "Volleyball",

  title: "Volleyball Court Construction",

  subtitle: "Professional Acrylic Volleyball Courts Built to FIVB Standards",

  heroImage,

  overviewImages: [overview1, overview2, overview3, overview4],

  heroStats: [
    {
      value: "1000+",
      label: "Courts Built",
    },

    {
      value: "15+",
      label: "Years Experience",
    },

    {
      value: "FIVB",
      label: "Certified/Standard",
    },

    {
      value: "2 Yr",
      label: "Warranty",
    },
  ],

  breadcrumb: ["Home", "Services", "Volleyball Court"],

  /* =====================================================
     OVERVIEW
  ====================================================== */

  overview: {
    title: "Professional Volleyball Court Construction",

    description:
      "Quality Sports Surface specializes in designing and constructing international-standard volleyball courts for schools, colleges, universities, sports academies, clubs, residential communities, and professional sports facilities. We use premium FIVB-compliant synthetic and wooden flooring systems engineered for durability, player safety, excellent shock absorption, and exceptional performance.",
  },

  /* =====================================================
     BENEFITS
  ====================================================== */

  benefits: [
    {
      title: "FIVB Standard Construction",
      description:
        "Designed according to international volleyball court specifications.",
    },
    {
      title: "Premium Sports Surface",
      description:
        "High-performance synthetic or wooden flooring with excellent grip and shock absorption.",
    },
    {
      title: "UV & Weather Resistant",
      description:
        "Built to withstand India's harsh climate and heavy rainfall.",
    },
    {
      title: "Low Maintenance",
      description:
        "Minimal maintenance with long-lasting color and surface quality.",
    },
  ],

  /* =====================================================
     CONSTRUCTION PROCESS
  ====================================================== */

  process: [
    {
      step: "01",
      title: "Site Inspection",
      description:
        "Complete site survey, measurements, and technical planning.",
    },

    {
      step: "02",
      title: "Base Preparation",
      description:
        "Concrete or asphalt base preparation with perfect leveling.",
    },

    {
      step: "03",
      title: "Acrylic Coating",
      description:
        "Multiple acrylic layers applied for strength and cushioning.",
    },

    {
      step: "04",
      title: "Court Marking",
      description: "Accurate FIBA-standard basketball court line marking.",
    },

    {
      step: "05",
      title: "Final Inspection",
      description: "Complete quality inspection before project handover.",
    },
  ],

  /* =====================================================
     TECHNICAL SPECIFICATIONS
  ====================================================== */

  specifications: [
    {
      icon: "🏀",
      feature: "Surface Type",
      value: "Premium Acrylic/ PVC and PU Sports Flooring",
    },

    {
      icon: "🌦",
      feature: "Weather Resistance",
      value: "Excellent",
    },

    {
      icon: "👟",
      feature: "Slip Resistance",
      value: "High Grip Finish",
    },

    {
      icon: "☀",
      feature: "UV Resistant",
      value: "100% UV Stable",
    },

    {
      icon: "🏆",
      feature: "FIVB Standard",
      value: "International Compliant",
    },

    {
      icon: "⏳",
      feature: "Expected Lifespan",
      value: "8+ Years",
    },

    {
      icon: "🛠",
      feature: "Maintenance",
      value: "Low Maintenance",
    },

    {
      icon: "🌍",
      feature: "Court Type",
      value: "Indoor & Outdoor",
    },
  ],

  /* =====================================================
     GALLERY
  ====================================================== */

  gallery: [
    {
      image: gallery1,
      title: "ABC International School",
      location: "New Delhi",
      surface: "Premium Acrylic Basketball Court",
      year: "2025",
    },

    {
      image: gallery2,
      title: "Delhi Public School",
      location: "Jaipur",
      surface: "Professional Acrylic Court",
      year: "2024",
    },

    {
      image: gallery3,
      title: "Sports Academy",
      location: "Lucknow",
      surface: "Outdoor Basketball Court",
      year: "2024",
    },

    {
      image: gallery4,
      title: "University Campus",
      location: "Chandigarh",
      surface: "FIBA Standard Court",
      year: "2023",
    },
  ],

  /* =====================================================
   WHY CHOOSE US — VOLLEYBALL
====================================================== */

  whyChoose: {
    tag: "WHY CHOOSE US",

    title: "Why Choose Our Professional Volleyball Court Flooring?",

    description:
      "We provide high-performance volleyball court flooring solutions designed for player safety, excellent shock absorption, controlled traction and consistent playing performance. From premium sports-grade materials to precision installation and professional court finishing, we deliver complete volleyball flooring solutions for indoor sports facilities.",

    features: [
      {
        title: "15+ Years Experience",
        description:
          "Over 15 years of experience delivering premium sports flooring and court solutions for schools, universities, academies, clubs and professional sports facilities across India.",
      },

      {
        title: "100+ Sports Projects",
        description:
          "Successfully completed 100+ sports flooring projects, including volleyball courts, indoor arenas, schools, colleges, training academies and multi-purpose sports facilities.",
      },

      {
        title: "Premium Sports-Grade Materials",
        description:
          "We use high-quality sports flooring materials selected for durability, resilience, consistent performance and suitability for demanding volleyball environments.",
      },

      {
        title: "Superior Shock Absorption",
        description:
          "Our volleyball flooring systems are designed to absorb impact and help reduce stress on players' knees, ankles and joints during repeated jumping, landing and rapid movement.",
      },

      {
        title: "Excellent Grip & Traction",
        description:
          "Professionally finished surfaces provide controlled traction and reliable grip, helping players move confidently during quick changes of direction, defensive movements and explosive jumps.",
      },

      {
        title: "Consistent Playing Surface",
        description:
          "Precision installation creates a smooth, uniform and responsive playing surface that supports predictable movement and consistent performance across the entire volleyball court.",
      },

      {
        title: "Player Safety Focused",
        description:
          "Our flooring solutions are designed with player comfort and safety in mind, providing a balanced combination of cushioning, traction and surface responsiveness.",
      },

      {
        title: "Professional Court Finishing",
        description:
          "We provide professional sanding, sealing, coating and court line marking to create a clean, attractive and competition-ready volleyball playing surface.",
      },

      {
        title: "Durable & Long-Lasting",
        description:
          "High-quality materials and professional installation help the flooring withstand intensive training sessions, tournaments and continuous daily use.",
      },

      {
        title: "Custom Volleyball Court Solutions",
        description:
          "We provide customized flooring solutions based on court dimensions, facility requirements, usage intensity, subfloor conditions, design preferences and project budget.",
      },

      {
        title: "Professional Installation Team",
        description:
          "Our experienced team manages subfloor preparation, flooring installation, surface finishing and court marking with careful attention to precision and overall playing performance.",
      },

      {
        title: "On-Time Project Delivery",
        description:
          "Our structured project management process ensures efficient execution and helps complete volleyball flooring projects within committed timelines.",
      },

      {
        title: "Complete Project Support",
        description:
          "From consultation and site assessment to flooring installation, court marking, maintenance guidance and after-sales assistance, we provide complete project support.",
      },

      {
        title: "Maintenance & After-Sales Support",
        description:
          "We provide practical maintenance recommendations and ongoing support to help preserve the flooring's grip, appearance, durability and playing performance.",
      },
    ],
  },

  /* =====================================================
     FAQ
  ====================================================== */

  faqs: [
    {
      question: "How long does volleyball court construction take?",
      answer:
        "Normally between 30-35 days depending on project size and site preparation.",
    },
    {
      question: "Can volleyball courts be constructed outdoors?",
      answer:
        "Yes, we construct both indoor wooden/PVC courts and highly durable, weather-resistant outdoor acrylic courts.",
    },
    {
      question: "How many years does the surface last?",
      answer:
        "With proper maintenance, the high-quality volleyball court surface typically lasts 8-10 years.",
    },
    {
      question: "Do you construct FIVB-standard courts?",
      answer:
        "Yes, we build volleyball courts strictly according to official FIVB (International Volleyball Federation) specifications.",
    },
  ],

  /* =====================================================
       RELATED SERVICES
    ====================================================== */

  relatedServices: [
    {
      icon: GiTennisCourt,
      title: "Tennis Court",
      description: "Professional ITF Standard Courts",
      link: "/services/tennis-court",
    },

    {
      icon: GiShuttlecock,
      title: "Badminton Court",
      description: "Professional BWF Standard Courts",
      link: "/services/badminton-court",
    },

    {
      icon: FaRunning,
      title: "Running Track",
      description: "Athletic Running Track Systems",
      link: "/services/running-track",
    },

    {
      icon: FaBasketballBall,
      title: "Basketball Court",
      description: "Professional FIBA Standard Courts",
      link: "/services/basketball-court",
    },
  ],

  /* =====================================================
     CTA
  ====================================================== */

  cta: {
    title: "Ready to Build Your Volleyball Court?",

    description:
      "Talk with our experts today and get a free consultation for your next sports infrastructure project.",
  },
};

export default volleyballData;
